import React, { useContext } from "react";
import { Heading as ChakraHeading } from "@chakra-ui/react";
import { SkeletonContext } from "./skeleton-context";
import { SkeletonText } from "./skeleton-text";
export function Heading({ isTruncated = false, children, size = "md", ...props }) {
    const skeleton = useContext(SkeletonContext);
    return (React.createElement(ChakraHeading, { position: skeleton ? "relative" : undefined, color: skeleton ? "transparent" : "text.primary", maxWidth: skeleton ? "max-content" : undefined, size: `heading-${size}`, variant: "heading", ...(isTruncated
            ? {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }
            : {}), ...props },
        children,
        skeleton && React.createElement(SkeletonText, null)));
}
